import { createSelector } from '@reduxjs/toolkit'

import { TMarketYoyGrowthExpectationWorkflowState } from '../../api/types'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/**
 * Global workflow status of the dataset, derived from the planning entry
 * (`Planning[0].Status`); `null` while no planning data is loaded. Per-record
 * `state` mirrors this value but is not the source of truth.
 */
export const selectMarketYoyGrowthExpectationsWorkflowState = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) =>
    state.planning
      ? (state.planning.status.toLowerCase() as TMarketYoyGrowthExpectationWorkflowState)
      : null
)
